import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import View from './view';
import * as Actions from './actions';
import * as RacksSelectors from 'shared_redux/selectors/models/racks';
import * as SettingsSelectors from 'shared_redux/selectors/view/settings';
import * as OrganizationsSelectors from 'shared_redux/selectors/models/organizations';

const mapStateToProps = (state) => {
    document.title = "Settings - Station";
    const currentOrganization = OrganizationsSelectors.getOrganization(state);

    return {
        racks: RacksSelectors.getRacks(state),
        station_auto_progress: SettingsSelectors.getOrganizationSettings(state).station_auto_progress,
        currentOrganization,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchSettings: Actions.fetchSettings,
        fetchRacks: Actions.fetchRacks,
        updateStationAutoProgress: Actions.updateStationAutoProgress,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;
